import React, { useState, useEffect } from 'react';
import { Button, Box, Typography } from '@mui/material';
import { useHPDTickets, usePendingHireRequests } from "../../../../reactQuery/violations";
import AddIcon from '@mui/icons-material/Add';
import './styles.scss';
import Heading from '../../../../components/Heading';
import Filters from './components/Filters';
import Table from './components/Table';
import PrimaryButton from '../../../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import { useCustomParams } from '../../../../hooks/useCustomParams';
import CustomTable from '../../../../components/Table/CustomTable';
import Loader from '../../../../components/Loader';
import NotRetainedFilter from './components/NotRetainedFilter';
import moment from 'moment';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { isAdmin } from '../../../../utils/helpers';
import HireUs from './components/HireUs';

const HPDViolations = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [status] = useCustomParams("status");
  const [search] = useCustomParams("search");
  const [pendingSearch] = useCustomParams("not-retained-search");
  const [filterParams, setFilterParams] = useState({
    page: 1,
    pageSize: 100,
    search: search || '',
    status: status || ''
  });

  // State for pending tickets table
  const [pendingPage, setPendingPage] = useState(0);
  const [pendingPageSize, setPendingPageSize] = useState(100);
  const [pendingFilterParams, setPendingFilterParams] = useState({
    page: 1,
    pageSize: 100,
    search: "",
  });

  const redirect = useNavigate();

  const {
    isLoading,
    responseData,
    totalRecords,
    refetch,
    isError,
    error,
    statusCounts,
    isRefetching
  } = useHPDTickets({page,pageSize,status: status || '',search: search || ''});

  // Get pending tickets data
    const {
      isLoading: isPendingLoading,
      responseData: pendingData,
      totalRecords: pendingTotalRecords,
      isError: isPendingError,
      error: pendingError,
      statusCounts: pendingStatusCounts,
      refetch: pendingRefetch,
    } = usePendingHireRequests(pendingFilterParams);

  useEffect(() => {
    setFilterParams({
      page: page + 1,
      pageSize,
      search: search || '',
      status: status || ''
    });

    
    
  }, [page, pageSize, search, status]);

    useEffect(() => {
      pendingRefetch();
    }, [pendingPage, pendingPageSize, pendingSearch]);

  useEffect(() => {
    refetch();
  }, [page, pageSize, search, status]);

  // Update pending filter params when pagination changes
  useEffect(() => {
    setPendingFilterParams({
      page: pendingPage + 1,
      pageSize: pendingPageSize,
      search: pendingSearch || "",
      is_hire_pending: true,
    });
  }, [pendingPage, pendingPageSize, pendingSearch]);

  const handleClick = () => {
    redirect("/hpd/tickets");
  };

  // Table columns definition for pending tickets
  const pendingTicketColumns = [
    {
      field: "client",
      headerName: "Client",
      renderCell: (params) => (
        <Typography variant="body2">{params.value}</Typography>
      ),
      minWidth: 180,
      flex: 1.5,
      sortable: false,
    },
    {
      field: "building_address",
      headerName: "Building",
      renderCell: (params) => (
        <Typography variant="body2">{params.value}</Typography>
      ),
      minWidth: 180,
      flex: 1.5,
      sortable: false,
    },
    {
      field: "unit_number",
      headerName: "Unit",
      renderCell: (params) => params.value ?
        <p className="unit-ticket">{params.value}</p> :
        <p >N/A</p>,
      minWidth: 80,
      flex: 0.5,
      sortable: false,
    },
    {
      field: "violation_code",
      headerName: "Violation Code",
      renderCell: (params) => (
        <Typography variant="body2">
          {params.row.violation?.order_number || "N/A"}
        </Typography>
      ),
      minWidth: 120,
      flex: 1,
      sortable: false,
    },
    {
      field: "violation_id",
      headerName: "Violation #",
      renderCell: (params) => (
        <Typography variant="body2">
          {params.row.violation.violation_id}
        </Typography>
      ),
      minWidth: 120,
      flex: 1,
      sortable: false,
    },
    {
      field: "correct_by_date",
      headerName: "Correct Date",
      renderCell: (params) => (
        <Typography variant="body2">
          {params.row.violation.correct_by_date
            ? moment(params.row.violation.correct_by_date).format("MM/DD/YYYY")
            : "N/A"}
        </Typography>
      ),
      minWidth: 120,
      flex: 1,
      sortable: false,
    },
    {
      field: "certify_by_date",
      headerName: "Certify Date",
      renderCell: (params) => (
        <Typography variant="body2">
          {params.row.violation.certify_by_date
            ? moment(params.row.violation.certify_by_date).format("MM/DD/YYYY")
            : "N/A"}
        </Typography>
      ),
      minWidth: 120,
      flex: 1,
      sortable: false,
    },
    ...(!isAdmin()
      ? [
          {
            field: "action",
            headerName: "Action",
            renderCell: (params) => (
              <HireUs params={params} refetch={pendingRefetch} />
            ),
            minWidth: 120,
            flex: 1,
            sortable: false,
          },
        ]
      : []),
  ];

  return (
    <div className="hpd-violations-container">
      <Heading
        title="HPD Violations (Retained)"
        svg={<ErrorOutlineIcon className="global-heading-icon" />}
      >
        {isAdmin() && (
          <PrimaryButton
            variant="contained"
            className={`capitalize btn-bg-orange `}
            onClick={handleClick}
            startIcon={<AddIcon />}
          >
            HPD Ticket
          </PrimaryButton>
        )}
      </Heading>

      <div className="mt-4 ">
        <Filters statusCounts={statusCounts} />

        <div className="">
          <Table
            isLoading={isLoading}
            isRefetching={isRefetching}
            isError={isError}
            error={error}
            data={responseData} // Replace with responseData when API is ready
            totalRecords={totalRecords}
            page={page}
            pageSize={pageSize}
            setPage={setPage}
            setPageSize={setPageSize}
          />
        </div>
      </div>

      {/* Pending Tickets Table Section */}
      <div className="pending-tickets-section mt-4">
        <Heading
          title=" Open HPD Lead/Mold Violations (NOT-Retained)"
          svg={<ErrorOutlineIcon className="global-heading-icon" />}
        />

        <div className=" mt-4">
          <NotRetainedFilter statusCounts={pendingStatusCounts} />
          {isPendingLoading ? (
            <div className="loader-center">
              <Loader color={"black"} />
            </div>
          ) : isPendingError ? (
            <div className="loader-center">
              <p>
                {pendingError?.response?.data?.message ||
                  "Error loading tickets"}
              </p>
            </div>
          ) : (
            <CustomTable
              initialRows={pendingData}
              columns={pendingTicketColumns}
              headerBgColor={"#F5F5F9"}
              rowCount={pendingTotalRecords}
              setPaginationModel={(data) => {
                setPendingPage(data.page);
                setPendingPageSize(data.pageSize);
              }}
              page={pendingPage}
              pageSize={pendingPageSize}
              subHeight={302}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HPDViolations; 